/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  InvalidateQueryFilters,
  QueryClient,
  useQuery,
  UseQueryResult,
  useSuspenseQuery,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  ListGatewaySessionFacetsRequest,
  ListGatewaySessionFacetsSecurity,
} from "../models/operations/listgatewaysessionfacets.js";
import { useGramContext } from "./_context.js";
import {
  QueryHookOptions,
  SuspenseQueryHookOptions,
  TupleToPrefixes,
} from "./_types.js";
import {
  buildGatewaySessionFacetsQuery,
  GatewaySessionFacetsQueryData,
  prefetchGatewaySessionFacets,
  queryKeyGatewaySessionFacets,
} from "./gatewaySessionFacets.core.js";
export {
  buildGatewaySessionFacetsQuery,
  type GatewaySessionFacetsQueryData,
  prefetchGatewaySessionFacets,
  queryKeyGatewaySessionFacets,
};

export type GatewaySessionFacetsQueryError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * listGatewaySessionFacets gatewaySessions
 *
 * @remarks
 * Complete configured member server and provider choices, independent of pagination and active filters.
 */
export function useGatewaySessionFacets(
  request?: ListGatewaySessionFacetsRequest | undefined,
  security?: ListGatewaySessionFacetsSecurity | undefined,
  options?: QueryHookOptions<
    GatewaySessionFacetsQueryData,
    GatewaySessionFacetsQueryError
  >,
): UseQueryResult<
  GatewaySessionFacetsQueryData,
  GatewaySessionFacetsQueryError
> {
  const client = useGramContext();
  return useQuery({
    ...buildGatewaySessionFacetsQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

/**
 * listGatewaySessionFacets gatewaySessions
 *
 * @remarks
 * Complete configured member server and provider choices, independent of pagination and active filters.
 */
export function useGatewaySessionFacetsSuspense(
  request?: ListGatewaySessionFacetsRequest | undefined,
  security?: ListGatewaySessionFacetsSecurity | undefined,
  options?: SuspenseQueryHookOptions<
    GatewaySessionFacetsQueryData,
    GatewaySessionFacetsQueryError
  >,
): UseSuspenseQueryResult<
  GatewaySessionFacetsQueryData,
  GatewaySessionFacetsQueryError
> {
  const client = useGramContext();
  return useSuspenseQuery({
    ...buildGatewaySessionFacetsQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

export function setGatewaySessionFacetsData(
  client: QueryClient,
  queryKeyBase: [
    parameters: {
      gatewayId?: string | undefined;
      gramSession?: string | undefined;
      gramKey?: string | undefined;
    },
  ],
  data: GatewaySessionFacetsQueryData,
): GatewaySessionFacetsQueryData | undefined {
  const key = queryKeyGatewaySessionFacets(...queryKeyBase);

  return client.setQueryData<GatewaySessionFacetsQueryData>(key, data);
}

export function invalidateGatewaySessionFacets(
  client: QueryClient,
  queryKeyBase: TupleToPrefixes<
    [parameters: {
      gatewayId?: string | undefined;
      gramSession?: string | undefined;
      gramKey?: string | undefined;
    }]
  >,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: [
      "@gram/client",
      "gatewaySessions",
      "listFacets",
      ...queryKeyBase,
    ],
  });
}

export function invalidateAllGatewaySessionFacets(
  client: QueryClient,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "gatewaySessions", "listFacets"],
  });
}
